module.exports = __webpack_public_path__ + "static/media/interMobile_2.3ffa3f7b.jpg";